export const SCHOOL = "/v1/school/";
export const FILE_UPLOAD = "/v1/upload/";
export const SCHOOL_LIST = "/v1/school/";

// School Commercial Installments
export const SCHOOL_COMMERCIALS_CREATE = "/v1/school/commercials/";
export const SCHOOL_COMMERCIALS_UPDATE = "/v1/school/commercials/"; // + :commercialId/
export const SCHOOL_INSTALLMENTS_CREATE = "/v1/school/installments/";
export const GET_INSTALLMENTS_DETAIL = "/v1/school/installments/detail/";
export const SCHOOL_INSTALLMENTS_UPDATE = "/v1/school/installments/"; // + :installmentId/
export const SCHOOL_INSTALLMENTS_CALCULATION_UPDATE = "/v1/school/installments/calculation/"; // + :installmentId/
export const SCHOOL_INSTALLMENTS_PDC = "/v1/school/installments/pdc/"; // + :installmentId/
export const SCHOOL_INSTALLMENTS_PDC_BY_FINANCE = "/v1/school/installments/pdc-finance/"; // + :installmentId/
export const SCHOOL_INSTALLMENTS_PDC_BY_SALES = "/v1/school/installments/pdc-sales/"; // + :installmentId/

export const CREATE_INVENTORY_STATUS = "/v1/school/inventory/status/";
export const UPDATE_INVENTORY_STATUS = "/v1/school/inventory/status/"; // + :statusId/
export const GET_INVENTORY_STATUS_BY_ID = "/v1/school/inventory/status/"; // + :schoolId/

// Payment
export const SCHOOL_INSTALLMENTS_INVOICE_PAYMENT = "/v1/school/invoice/payment/"; // + :installmentId/

// School Edit: GETs
export const SCHOOL_DETAILS_BY_ID = "/v1/school/"; // + :schoolId/
export const SCHOOL_COMMERCIALS_BY_SCHOOL_ID = "/v1/school/commercials/"; // + :schoolId/
export const SCHOOL_INSTALLMENTS_BY_COMMERCIAL_ID = "/v1/school/installments/"; // + :commercialId/
export const SCHOOL_INSTALLMENT_INVOICE_BY_INSTALLMENT_ID = "/v1/school/invoice/"; // + :commercialId/
export const SCHOOL_INSTALLMENT_RECEIPT_DETAILS_BY_INSTALLMENT_ID = "/v1/school/installments/receipt/"; // + :commercialId/
export const SCHOOL_INSTALLMENT_RECEIPT_DOWNLOAD_BY_INSTALLMENT_ID = "/v1/school/installments/receipt/download/"; // + :commercialId/

// Lab
export const SCHOOL_LAB_POC_CREATE = "/v1/school/lab/poc/";
export const SCHOOL_INVENTORY_DETAIL_CREATE = "/v1/school/inventory/detail/";
export const SCHOOL_LAB_POC_BY_SCHOOL_ID = "/v1/school/lab/poc/"; // + :schoolId/
export const SCHOOL_INVENTORY_DETAIL_BY_SCHOOL_ID = "/v1/school/inventory/detail/"; // + :schoolId/
export const SCHOOL_LAB_POC_UPDATE = "/v1/school/lab/poc/"; // + :pocId/
export const SCHOOL_INVENTORY_DETAIL_UPDATE = "/v1/school/inventory/detail/";
export const SCHOOL_LAB_RESOURCES_CREATE = "/v1/school/lab/resource/";
export const SCHOOL_LAB_RESOURCES_BY_SCHOOL_ID = "/v1/school/lab/resource/"; // + :schoolId/
export const SCHOOL_LAB_RESOURCES_UPDATE = "/v1/school/lab/resource/"; // + :resourceId/
export const SCHOOL_LAB_SETUP_CREATE = "/v1/school/lab/setup/";
export const SCHOOL_LAB_SETUP_BY_SCHOOL_ID = "/v1/school/lab/setup/"; // + :schoolId/
export const SCHOOL_LAB_SETUP_UPDATE = "/v1/school/lab/setup/";
// CRM Class Management
export const CRM_CLASS_CREATE = "/v1/school/crm/class/";
export const CRM_CLASS_BY_SCHOOL_ID = "/v1/school/crm/class/"; // + :schoolId/
export const CRM_CLASS_DELETE = "/v1/school/crm/class/"; // + :classId/

// School POC Management
export const SCHOOL_LAB_POC = "/v1/school/crm/school-poc/";